import { ModuleWithProviders } from '@angular/core';
import { StoreModule, ActionReducerMap } from '@ngrx/store';
import { appReducer, initialAppState } from './app.reducer';
import { IAppState } from './app.state';


export interface AppState {
  app: IAppState;
}

export const reducers: ActionReducerMap<AppState> = {
  app: appReducer
};

export function appStateStore(): ModuleWithProviders {
  return  StoreModule.forRoot(reducers, { initialState:  {app: initialAppState}});
}




// WEBPACK FOOTER //
// ./src/app/appState/appStateStore.module.ts